export default __webpack_public_path__ + "static/media/eye.75daf469.svg";